const getBrowserLanguage = () => {
  const userLanguage = window.navigator.languages ? window.navigator.languages[0] : null;
  const language = userLanguage || window.navigator.language;

  return language.slice(0, 2);
};

export default getBrowserLanguage;
